const formats = [
  { icon: 'ri-calendar-check-line', title: 'Корпоративный тренинг', desc: 'Практическая программа на 1–3 дня под конкретные управленческие задачи компании.' },
  { icon: 'ri-stack-line', title: 'Модульная программа', desc: 'Несколько обучающих модулей с практикой между встречами и закреплением навыков.' },
  { icon: 'ri-award-line', title: 'Комплексная программа развития', desc: 'Последовательное развитие нескольких управленческих компетенций в течение нескольких месяцев.' },
  { icon: 'ri-gamepad-line', title: 'Бизнес-игры', desc: 'Моделирование управленческих ситуаций и практическая отработка навыков в безопасной среде.' },
  { icon: 'ri-user-voice-line', title: 'Коучинг руководителей', desc: 'Индивидуальная работа с конкретными управленческими задачами и ситуациями руководителя.' },
  { icon: 'ri-group-line', title: 'Управленческая фасилитация', desc: 'Помощь команде руководителей в принятии решений, выработке договорённостей и работе со сложными вопросами.' },
  { icon: 'ri-user-heart-line', title: 'Сопровождение', desc: 'Разбор реальных ситуаций и поддержка внедрения инструментов после обучения.' },
];

export default function FormatsSection() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Форматы развития управленческих компетенций
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Как может проходить обучение — формат подбирается под задачу компании и уровень руководителей
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {formats.map((f) => (
            <div key={f.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${f.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{f.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}